import React from 'react';
import { DownOutlined } from '@ant-design/icons';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import { CheckboxDropDown } from '../../FilterComponents/CheckboxDropdownOverlay/CheckboxDropdownOverlay';

import styles from './index.module.css';
import { getIn } from 'formik';

const renderSelectedOrganizationTags = ({ selectedItems, setFieldValue, name, options }) => {
  if (!selectedItems?.length) return null;

  const removeItem = (id) => (event) => {
    event.stopPropagation();
    event.preventDefault();
    const next = selectedItems.filter((item) => (item.id || item) !== id);
    setFieldValue(name, next);
  };

  const renderChip = (item) => {
    const isObject = typeof item === 'object' && item !== null;
    const id = isObject ? item.id : item;
    const nameLabel = isObject ? item.name : options?.find((o) => o.value === item)?.title || item;

    return (
      <span className={styles.chip} key={id}>
        <span className={styles.chipText}>{nameLabel}</span>
        <button
          type='button'
          className={styles.chipRemove}
          onClick={removeItem(id)}
          aria-label={`Remove ${nameLabel}`}>
          ×
        </button>
      </span>
    );
  };

  if (selectedItems.length <= 2) {
    return selectedItems.map(renderChip);
  }

  const [first] = selectedItems;
  const extraCount = selectedItems.length - 1;

  return (
    <>
      {renderChip(first)}
      <span className={styles.chipSummary} aria-label={`${extraCount} more selected`}>
        +{extraCount}...
      </span>
    </>
  );
};

const renderDropDownComponent =
  ({ myClassName, hasValues, value, title, showSelectedAsTags, selectedItems, setFieldValue, name, options }) =>
  ({ visible }) => {
    let labelContent = title;
    if (showSelectedAsTags && hasValues) {
      labelContent = renderSelectedOrganizationTags({ selectedItems, setFieldValue, name, options });
    } else if (hasValues && !visible) {
      labelContent = value;
    } else if (hasValues && visible) {
      labelContent = title;
    }

    return (
      <div
        className={classnames({
          [styles.headRow]: true,
          [myClassName]: myClassName,
          [styles.headRowActive]: visible,
          [styles.headRowDisabled]: !visible,
        })}>
        <span
          className={classnames({
            [styles.cellTitle]: true,
            [styles.cellTitleTags]: showSelectedAsTags && hasValues,
            [myClassName]: myClassName,
          })}>
          {labelContent}
        </span>
        <DownOutlined
          className={classnames({
            [styles.icon]: true,
            [styles.disabled]: !visible,
          })}
        />
      </div>
    );
  };

export const FilterCheckboxListCell = ({
  value,
  name,
  title,
  values,
  myClassName,
  showSelectedAsTags = false,
  setFieldValue,
  ...rest
}) => (
  <CheckboxDropDown
    {...rest}
    setFieldValue={setFieldValue}
    values={values}
    name={name}
    title={title}
    Component={renderDropDownComponent({
      myClassName,
      value,
      hasValues: (getIn(values, name) || []).length > 0,
      title,
      showSelectedAsTags,
      selectedItems: getIn(values, name) || [],
      setFieldValue,
      name,
      options: rest.options,
    })}
  />
);

FilterCheckboxListCell.propTypes = {
  value: PropTypes.string,
  options: PropTypes.array,
  name: PropTypes.string,
  title: PropTypes.string,
  values: PropTypes.object,
  myClassName: PropTypes.string,
  showSelectedAsTags: PropTypes.bool,
  setFieldValue: PropTypes.func,
};
